import axios from '../shared/axios';
import * as events from './events';

export function saveCertificate(data) {
    return new Promise((resolve, reject) => {
        axios.post(`/api/Certificate/SaveCertificate`, data)
            .then(result => {
                events.onNotification_CREATED();
                resolve(result);
            })
            .catch(error => reject(error));
    });
}

export function updateCertificate(data) {
    return new Promise((resolve, reject) => {
        axios.post(`/api/Certificate/Update`, data)
            .then(result => {
                switch (data.actioncode) {
                    case 'SAVE_DRAFT':
                        events.onNotification_DRAFT_SAVED();
                        break;
                    case 'COMMUNICATE':
                        events.onNotification_COMMUNICATED();
                        break;
                    case 'REPLY_DRAFT':
                        events.onNotification_REPLY_DRAFT_SAVED();
                        break;
                    case 'REPLY_SEND':
                        events.onNotification_REPLY_SENT();
                        break;
                    default:
                        alert('Unknown action code!');
                        break;
                }

                resolve(result);
            })
            .catch(error => reject(error));
    });
}

export function getCertificate(certificateid) {
    return axios.get(`/api/Certificate/GetCertificate?certificateid=${certificateid}`);
}

export function getCertificates(companyid, projectid, contractid, type, accessibleWfIds) {
    return axios.post(`/api/Certificate/LoadCertificatesList`, { accessibleWfIds }, { params: { companyid, projectid, contractid, type } });
}

export function deleteCertificateDraft(certificateid) {
    return new Promise((resolve, reject) => {
        axios.post(`api/Certificate/DeleteDraft?certificateid=${certificateid}`)
            .then(result => {
                events.onNotification_DELETED();
                resolve(result);
            })
            .catch(error => reject(error));
    })
}

export function importCertificates(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.post(`/api/Certificate/Import`, data);
            events.onNotification_CREATED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}

export function deleteCertificateDrafts(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.delete(`/api/Certificate/BulkDeleteDraft`, { data: data });
            events.onNotification_DELETED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}

export function communicateCertificateDrafts(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.put(`/api/Certificate/BulkCommunicate`, data);
            events.onNotification_COMMUNICATED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}